import { Link } from "@tanstack/react-router";
import { Info } from "lucide-react";

/**
 * Site-wide editorial disclaimer. Rendered at the bottom of every article and
 * hub page so the same wording appears consistently across LifeWestWay.
 */
export function ArticleDisclaimer({ className = "" }: { className?: string }) {
  return (
    <aside
      aria-label="Editorial disclaimer"
      className={`not-prose mt-12 rounded-2xl border border-accent/25 bg-card/60 p-5 sm:p-6 ${className}`}
    >
      <div className="flex items-start gap-3">
        <span
          aria-hidden
          className="mt-0.5 grid h-8 w-8 shrink-0 place-items-center rounded-lg border border-accent/30 bg-accent/10 text-accent"
        >
          <Info className="h-4 w-4" />
        </span>
        <div>
          <h2 className="font-display text-sm font-bold uppercase tracking-[0.18em] text-accent">
            Disclaimer
          </h2>
          <p className="mt-2 text-sm leading-6 text-foreground/75">
            This article is for general informational purposes only and does not constitute legal,
            tax, immigration, or financial advice. Always verify current requirements with official
            government sources or a licensed professional.
          </p>
          <p className="mt-3 text-xs text-muted-foreground">
            Read how we research, review, and update our guides in{" "}
            <Link title="Read the LifeWestWay editorial process" to="/editorial-process" className="font-semibold text-accent hover:underline">
              Our Editorial Process
            </Link>
            .
          </p>
        </div>
      </div>
    </aside>
  );
}
